import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* stripe({ payload }) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.CREATE_CHECKOUT_SESSION,
      data: { priceId: payload.price },
    });
    const { data } = res;
    payload.stripe.redirectToCheckout({
      sessionId: data.sessionId,
    });
    yield put({ type: 'GET_STRIPE_SESSION_SUCCESS', data });
  } catch (e) {
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_STRIPE_SESSION, stripe);
}
